<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat class="card-header">
        <v-btn icon exact :to="{name: 'interests'}"><v-icon>clear</v-icon></v-btn>
        <span class="title">Edit Interest</span>
        <v-spacer></v-spacer>
        <v-btn @click="saveItem" depressed class="mx-1" color="success">Save</v-btn>
        <v-btn @click="showDeleteDialog = true" depressed class="mx-1" color="error">Delete</v-btn>
      </v-toolbar>
      <v-container grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
            v-model="item.name"
            label="Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
            v-model="item.description"
            label="Description"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-dialog v-model="showDeleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Delete Item</v-card-title>
        <v-card-text class="pt-4">
          Are you sure you want to delete this item?  <b>This action cannot be undone.</b>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="deleteItem">I'm sure</v-btn>
          <v-btn text @click="showDeleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      item: {},
      loading: false,
      showDeleteDialog: false
    }
  },

  created () {
    this.getItem()
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ]),

    isNew: function () {
      if (this.$route.params.id === 'new') {
        return true
      }
      return false
    }
  },

  methods: {
    exit: function () {
      this.$router.go(-1)
    },

    deleteItem: function () {
      ApiRequests.interestDelete(this.item._id).then(r => {
        this.exit()
      })
    },

    getItem: function () {
      if (this.isNew) return

      this.loading = true
      ApiRequests.interestGet(this.$route.params.id).then(r => {
        this.item = r.data
        this.loading = false
      })
    },

    saveItem: function () {
      this.loading = true

      if (this.isNew) {
        this.item.site = this.selectedSite._id
        ApiRequests.interestCreate(this.item).then(r => {
          this.item = r.data
          this.loading = false
          this.exit()
        })
      } else {
        ApiRequests.interestSave(this.item).then(r => {
          this.item = r.data
          this.loading = false
          this.exit()
        })
      }
    }
  }
}
</script>
